module.exports = __webpack_public_path__ + "fonts/LatoLatin-MediumItalic.59db2b69.woff";